module.exports = __webpack_public_path__ + "img/closeBlack.0656866f.svg";